var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('q-card',{staticClass:"login-card col-xl-4 col-md-4 col-sm-8 col-11",staticStyle:{"margin-top":"50px !important","border-radius":"20px"}},[_vm._t("toolbar"),_c('q-card-section',{attrs:{"vertical":"","align":"center"}},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }